import React, { useEffect, useState } from 'react';
import './ValidationReferencesSummary.scss';
import IconItem from '../../../../../../components/Item/IconItem/IconItem';
import { faArrowLeft, faArrowRight, faClose } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import CURRENCY from 'utils/constants/currency';
import { Trans, useTranslation } from 'react-i18next';
import Pagination from 'components/pagination/Pagination';
import { formatNumberWithSpaces } from 'utils/utils';
import { IParts } from 'interfaces/price';
import { useDispatch } from 'react-redux';
import { setCloseModal } from 'store/slices/proformaAutomotorModal.slice';

type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
  stepModalNext: string;
};

const ValidationReferencesSummary: React.FC<Props> = (props) => {

  const { t } = useTranslation();

  const [data, setData] = useState<Array<IParts>>([]);
  const user = JSON.parse(localStorage.getItem('userData')!);
  const [dataPagination, setDataPagination] = useState<Array<IParts>>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(5);
  const [totalPages, setTotalPages] = useState<number>(0);
  const dispatch = useDispatch();

  const handleClose = () => {
    props.setOpenModal(false);
    dispatch(setCloseModal(true));
  };

  useEffect(() => {
    if (props.stepModalNext === 'ValidationReferencesSummary') {
      const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
      const references = proformaFile?.order_items || [];
      const excludeRenCodFou = references.filter((item) => item.info?.codfou !== 'REN');

      const formattedData = excludeRenCodFou.map((part, index) => {
        return {
          'index': index,
          'reference': part.info.reference_full,
          'description': part.info.description,
          'supplier_name': part.info.supplier_name,
          'name': part.info.supplier_name,
          'supplier_logo': part.info.supplier_logo,
          'price': part.info.price,
          'quantity': part.info.quantity,
          'total': Number(part.info.price) * Number(part.info.quantity)
        };
      });

      setData(formattedData);

    }
  }, [props.stepModalNext]);

  useEffect(() => {
    if (data.length > 0) {


      const total = data.length;

      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;

      setTotalPages(Math.ceil(total / itemsPerPage));
      setDataPagination(data.slice(startIndex, endIndex));
    }


  }, [data, currentPage]);


  const handlePageClick = (page: number) => {


    setCurrentPage(page);

  };


  return (
    <div className="validation-custumer-order-summary-modal" >
      <div className="close upload_order_info_summary_close">
        <IconItem icon={faClose} onClick={() => { handleClose(); }} />
      </div>


      <div className="validation-customer-modal-body">
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-title">{t('_title_summary_screen_of_the_order')}</div>
          <div className="validation-customer-modal-subtitle">
            <Trans
              i18nKey="_validation_summary_screen_message"
              components={{ bold: <br /> }}

            />
          </div>
        </div>
        <div className="validation-customer-modal-row">

          <table className="validation-customer-modal-table">
            <thead>
              <tr >
                <th className="text-align-left"> {t('_reference')} / {t('_description')}</th>
                <th >{t('_brand')}</th>
                <th >{t('_current_unit_rate')}</th>
                <th >{t('_quantity_order')}</th>
                <th >{t('_total')}</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                dataPagination.map((row, index) => (
                  <tr key={row.reference! + index}>
                    <td className="text-align-left">{row.description ? `${row.reference ?? ''} / ${row.description}` : row.reference ?? ''}</td>
                    <td >
                      <div className="brand">
                        <div>
                          <img src={row.supplier_logo ? row?.supplier_logo : '/images/car-part-placeholder-big.png'} onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = '/images/car-part-placeholder-big.png';
                          }} alt="Logo" height={16}
                          />
                        </div>

                        <div>{row.supplier_name || row.name}</div>

                      </div>
                    </td>
                    <td>{row.price ? formatNumberWithSpaces(Number(row.price).toFixed(2)) + ' ' + CURRENCY[user!.currency] : '-'}</td>
                    <td>{row.quantity}</td>
                    <td>{row.total ? formatNumberWithSpaces(Number(row.total).toFixed(2)) + ' ' + CURRENCY[user!.currency] : '-'}</td>


                  </tr>)))
                :
                <tr>
                  <td colSpan={4} className="no-data">{t('_no_data')}</td>
                </tr>
              }


            </tbody>
          </table>
          {totalPages > 1 && (
            <Pagination pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} hiddenParamPage iconsPrevious={faArrowLeft} iconsNext={faArrowRight} />
          )}
        </div>
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-button">
            <DefaultButton className="validation-customer-modal-btn upload_order_summary_go_to_info_result" text={t('_summary_button')} onClick={() => { props.setStepModal('ValidationReferencesResultInfo'); }} />

            {/* <DefaultButton className="validation-customer-modal-btn cancel upload_order_info_summary_cancel" text={t('_cancel')} onClick={() => { handleClose(); }} /> */}

          </div>

        </div>

      </div>
    </div>
  );

};

ValidationReferencesSummary.displayName = 'ValidationReferencesSummary';

export default ValidationReferencesSummary;